import React, { useState } from 'react';
import { AlignLeft, CheckSquare, Clock, MessageCircle, MoreHorizontal } from 'react-feather';
import { formatDate } from '../../helpers/Util';
import { ICard, IComment, ILabel } from '../../interfaces/trello';
import Chip from '../Common/Tags';
import Dropdown from '../UI/Button/Dropdown/Dropdown';

import './Card.css';
import CardInfo from './CardInfo/CardInfo';
interface CardProps {
  card: ICard;
  boardId: number;
  labels: ILabel[];
  comments: IComment[];
  removeCard: (boardId: number, cardId: number) => void;
  onDragEnd: (boardId: number, cardId: number) => void;
  onDragEnter: (boardId: number, cardId: number) => void;
  updateCard: (boardId: number, cardId: number, card: ICard) => void;
  onDragStart: (boardId: number, cardId: number) => void;
}
function Card(props: CardProps) {
  const { card, boardId, removeCard, onDragEnd, onDragEnter, updateCard, onDragStart, labels: labelList, comments } =
    props;
  const { id, title, desc, date, tasks, labels } = card;
  const [showDropdown, setShowDropdown] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [dragStartClass, setDragStartClass] = useState('')

  return (
    <>
      {showModal && (
        <CardInfo
          labels={labelList}
          onClose={() => setShowModal(false)}
          card={card}
          boardId={boardId}
          updateCard={updateCard}
        />
      )}
      <div
        className={`card ${dragStartClass}`}
        key={card.id}
        draggable
        onDrop={(e) => {
          e.preventDefault();
          setDragStartClass('')

        }}
        onDragEnd={(e) => {
          e.preventDefault()
          onDragEnd(boardId, id)
          setDragStartClass('')
        }}
        onDragEnter={(e) => {
          e.preventDefault();

          onDragEnter(boardId, id)

        }}
        onDragLeave={() => {
          setDragStartClass('')
        }}
        onDragStart={() => {
          onDragStart(boardId, id)
          setDragStartClass('cardHold')
          setTimeout(() => (setDragStartClass('cardInvisible')), 0);
        }}
        onDragOver={(e) => {
          setDragStartClass('cardHovered')
          e.preventDefault()
        }}
        onClick={() => setShowModal(true)}
      >
        <div className="card-top">
          <div className="card-top-labels">
            {labels?.map((item, index) => (
              <Chip key={index} item={item} />
            ))}
          </div>
          <div
            className="card-top-more"
            onClick={(event) => {
              event.stopPropagation();
              setShowDropdown(true);
            }}
          >
            <MoreHorizontal />
            {showDropdown && (
              <Dropdown
                class="board-dropdown"
                onClose={() => setShowDropdown(false)}
              >
                <p onClick={() => removeCard(boardId, id)}>Delete Card</p>
              </Dropdown>
            )}
          </div>
        </div>
        <div className="card-title">{title}</div>
        <div>
          <p title={desc}>
            <AlignLeft />
          </p>
        </div>
        <div className="card-footer">
          {date && (
            <p className="card-footer-item">
              <Clock className="card-footer-icon" />
              {formatDate(date)}
            </p>
          )}
          {comments?.length > 0 && (
            <p className="card-footer-item">
              <MessageCircle className="card-footer-icon" />
              {comments?.length}
            </p>
          )}
          {tasks && tasks?.length > 0 && (
            <p className="card-footer-item">
              <CheckSquare className="card-footer-icon" />
              {tasks?.filter((item) => item.completed)?.length}/{tasks?.length}
            </p>
          )}
        </div>
      </div>
    </>
  );
}

export default Card;
